import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { User } from '../../@types';
import { useAuth } from '../../hooks';

export const getUserProfile = async (): Promise<User> => {
  const res = await axiosInstance.get('/api/users/get-user');
  return res.data;
};

export function useGetUserProfile() {
  const {
    auth: { isAuthenticated },
  } = useAuth();
  return useQuery(['getUserProfile'], getUserProfile, {
    enabled: isAuthenticated,
  });
}
